module.exports = __webpack_public_path__ + "img/baiwan.298b6d09.webp";